import { Pipe, PipeTransform } from "@angular/core";
import { PrescriptionsModel } from "../models/history.model";
import * as _ from 'lodash';

@Pipe({ name: 'orderhistory' })
export class OrderHistoryPipe implements PipeTransform {
    transform(array: PrescriptionsModel[], history_order: number) {
        let result: PrescriptionsModel[] = [];
// debugger;
        // result.push(..._.filter(array, row => row.history_sequence === history_sequence));
        switch (history_order) {
            case 1:
                result.push(...array.sort((a, b) => (a.ticks_drug_note_date > b.ticks_drug_note_date) ? -1 : 1));
                break;
            case 2:
                result.push(...array.sort((a, b) => (a.ticks_drug_note_date < b.ticks_drug_note_date) ? -1 : 1));
                break;
            case 3:
                result.push(...array.sort((a, b) => (a.product_name < b.product_name) ? -1 : 1));
                break;
            case 4:
                result.push(...array.sort((a, b) => (a.product_name > b.product_name) ? -1 : 1));
                break;
            case 5:
                result.push(...array.sort((a, b) => (a.in_clinic > b.in_clinic) ? -1 : 1));
                break;
            case 6:
                result.push(...array.sort((a, b) => (a.in_clinic < b.in_clinic) ? -1 : 1));
                break;
        }

        return result; //
    }
}